// extracted by mini-css-extract-plugin
export default {"landscapeAboutParticipantWrapper":"LandscapeAboutParticipantPage_landscapeAboutParticipantWrapper__9Y+0q"};